import React from 'react';
import { Row } from 'react-grid-system';
import useTranslate from '@Utils/hooks/useTranslate';
import Divider from '@Components/Divider/Divider';
import RadioButton from '@Components/controls/RadioButton/RadioButton';
import { SelectedAddressType } from '../../ShippingMethod/ShippingMethod';

interface IInternetInstallation {
	addressType: SelectedAddressType;
	setAddressType: (type: SelectedAddressType) => void;
}

const InternetInstallation = ({ addressType, setAddressType }: IInternetInstallation): JSX.Element => {
	const { translate } = useTranslate();
	return (
		<Row>
			<RadioButton
				label={translate('shipping-method.same.as.internet.installation')}
				selected={addressType}
				onClick={() => {
					setAddressType(SelectedAddressType.SAME_AS_INTERNET_INSTALLATION);
				}}
				name="radio"
				value={SelectedAddressType.SAME_AS_INTERNET_INSTALLATION}
				marginRight={0}
			/>
			<Divider withoutLine marginBottom={16} />
		</Row>
	);
};

export default InternetInstallation;
